import { BookingButton } from "./BookingButton";
import { useLanguage } from "../../i18n/LanguageContext";

export function HeroSection({ isMobile }: { isMobile?: boolean }) {
  const { t } = useLanguage();
  return (
    <section
      className={`relative w-full overflow-hidden ${
        isMobile ? "h-[360px]" : "h-[560px]"
      }`}
    >
      <div
        className="absolute inset-0 hidden md:block"
        style={{
          backgroundImage:
            "linear-gradient(90deg, rgba(8,20,15,0.70) 0%, rgba(8,20,15,0.54) 30%, rgba(8,20,15,0.28) 55%, rgba(8,20,15,0.08) 100%), url('/a16/landing1.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center center",
        }}
      />

      <div
        className="absolute inset-0 block md:hidden"
        style={{
          backgroundImage:
            "linear-gradient(180deg, rgba(8,20,15,0.72) 0%, rgba(8,20,15,0.52) 45%, rgba(8,20,15,0.18) 100%), url('/a16/landing1.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center center",
        }}
      />

      <div className="relative z-10 mx-auto flex h-full max-w-7xl items-start justify-start">
        <div className="w-full px-4 pt-[50px] md:px-8 md:pt-[138px]">
          <div className={`max-w-4xl ${isMobile ? "mx-auto text-center" : ""}`}>
            <p className="text-white text-3xl font-semibold leading-[1.05] tracking-[-0.03em] md:text-5xl drop-shadow-[0_10px_30px_rgba(0,0,0,0.22)]">
              {t("herotitle")}{" "}
              <br className="md:hidden"/>
              <span className="hero-highlight-text">{t("herosubtitle")} </span>
            </p>

            <p
              className={`mt-5 md:max-w-xl max-w-xs text-sm leading-7 text-white/90 md:text-[1.05rem] ${
                isMobile ? "mx-auto" : ""
              }`}
            >
              {t("herodescription")}
            </p>

            <div
              className={`mt-8 flex ${
                isMobile ? "justify-center" : "justify-start"
              }`}
            >
              <BookingButton isMobile={isMobile}>
                {t("datlichkhamngay")}
              </BookingButton>
            </div>
          </div>
        </div>
      </div>

      <svg
        className="absolute -bottom-1 -right-1 z-[1]"
        viewBox="0 0 1280 30"
        fill="none"
      >
        <path
          d="M2.62268e-06 30.0001L1280 30L1280 0C1280 0 1084.58 13.8806 914.643 13.8806C744.709 13.8806 533.792 6.52356e-05 363.858 8.00917e-05C193.924 9.49478e-05 1.21348e-06 13.8807 1.21348e-06 13.8807L2.62268e-06 30.0001Z"
          className="fill-brand-primary"
        />
      </svg>
    </section>
  );
}
